import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MENU, CLOSE } from './icons';

const Header = () => {
    const [isOpen, setOpen] = useState(false);
    useEffect(() =>
        toggleClick()
        , [])
    function toggleClick() {
        let id = "5a43509";
        var toggle = document.querySelector('.elementor-element-' + id + ' .hfe-nav-menu__toggle');
        var nextElement = toggle.nextElementSibling;
        let large_width = document.querySelector(".elementor-element-ce42220").offsetWidth

        let left = (document.querySelector(".elementor-element-ce42220").parentElement.parentElement.offsetWidth - document.querySelector(".elementor-element-ce42220").offsetWidth) > 50 ? 50 : 41;;
        if (toggle.classList.contains('hfe-active-menu-full-width')) {
            nextElement.style.left = '0';

            var width = toggle.closest('.elementor-section').offsetWidth;
            var sec_pos = toggle.closest('.elementor-section').offsetLeft - nextElement.offsetLeft;
            nextElement.style.width = large_width + 'px';
            nextElement.style.left = left + 'px';
        }

        toggle.addEventListener('click', function (event) {
            var layout = document.querySelector('.elementor-element-' + id + ' .hfe-nav-menu').dataset.layout;
            var full_width = nextElement.dataset.fullWidth;
            var toggle_icon = document.querySelector('.elementor-element-' + id + ' nav').dataset.toggleIcon;

            var navMenuIcon = document.querySelector('.elementor-element-' + id + ' .hfe-nav-menu-icon');
            navMenuIcon.innerHTML = toggle_icon;

            if (toggle.classList.contains('hfe-active-menu')) {
                toggle.classList.remove('hfe-active-menu');
                toggle.setAttribute('aria-expanded', 'false');

                if (full_width == 'yes') {
                    toggle.classList.remove('hfe-active-menu-full-width');
                    nextElement.style.width = 'auto';
                    nextElement.style.left = '0';
                    nextElement.style.zIndex = '0';
                }
            } else {
                var close_icon = document.querySelector('.elementor-element-' + id + ' nav').dataset.closeIcon;
                navMenuIcon.innerHTML = close_icon;

                toggle.classList.add('hfe-active-menu');
                toggle.setAttribute('aria-expanded', 'true');

                if (full_width == 'yes') {
                    toggle.classList.add('hfe-active-menu-full-width');
                    var width = toggle.closest('.elementor-section').offsetWidth;
                    var sec_pos = toggle.closest('.elementor-section').offsetLeft - nextElement.offsetLeft;
                    nextElement.style.width = large_width + 'px';
                    nextElement.style.left = left + 'px';
                    nextElement.style.zIndex = '9999';
                }
            }

            var nav = document.querySelector('.elementor-element-' + id + ' nav');
            if (nav.classList.contains('menu-is-active')) {
                nav.classList.remove('menu-is-active');
                setOpen(false);
            } else {
                nav.classList.add('menu-is-active');
                setOpen(true);
            }
        });
    }

    return <header
        id="masthead"
        itemScope="itemscope"
        itemType="https://schema.org/WPHeader"
        className="site-header"
    >
        <p className="main-title bhf-hidden" itemProp="headline">
            <a href="/" title="" rel="home" />
        </p>
        <div
            data-elementor-type="wp-post"
            data-elementor-id={451}
            className="elementor elementor-451 "
        >
            <section
                className="elementor-section elementor-top-section elementor-element elementor-element-5e85dd8 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                data-id="5e85dd8"
                data-element_type="section"
            >
                <div className="elementor-container elementor-column-gap-default">
                    <div
                        className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ce42220"
                        data-id="ce42220"
                        data-element_type="column"
                        data-settings='{"background_background":"classic"}'
                    >
                        <div className="elementor-widget-wrap elementor-element-populated">
                            <section
                                className="elementor-section elementor-inner-section elementor-element elementor-element-7407b9c elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                data-id="7407b9c"
                                data-element_type="section"
                            >
                                <div className="elementor-container elementor-column-gap-default">
                                    <div
                                        className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-45de37f"
                                        data-id="45de37f"
                                        data-element_type="column"
                                    >
                                        <div className="elementor-widget-wrap elementor-element-populated">
                                            <div
                                                className="elementor-element elementor-element-b07457a elementor-widget elementor-widget-image"
                                                data-id="b07457a"
                                                data-element_type="widget"
                                                data-widget_type="image.default"
                                            >
                                                <div className="elementor-widget-container">
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                '/*! elementor - v3.16.0 - 20-09-2023 */\n.elementor-widget-image{text-align:center}.elementor-widget-image a{display:inline-block}.elementor-widget-image a img[src$=".svg"]{width:48px}.elementor-widget-image img{vertical-align:middle;display:inline-block}'
                                                        }}
                                                    />{" "}
                                                    <img
                                                        style={{
                                                            height: '60px',
                                                            width: 'auto',
                                                            overflow: 'hidden',
                                                        }}
                                                        src="/assets/logo.jpg"
                                                        alt="logo"
                                                    />{" "}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-d74136a"
                                        data-id="d74136a"
                                        data-element_type="column"
                                    >
                                        <div className="elementor-widget-wrap elementor-element-populated">
                                            <div
                                                className="elementor-element elementor-element-5a43509 hfe-nav-menu__align-right hfe-submenu-icon-arrow hfe-submenu-animation-none hfe-link-redirect-child hfe-nav-menu__breakpoint-tablet elementor-widget elementor-widget-navigation-menu"
                                                data-id="5a43509"
                                                data-element_type="widget"
                                                data-settings='{"menu_space_between":{"unit":"px","size":37,"sizes":[]},"dropdown_border_radius":{"unit":"px","top":"10","right":"10","bottom":"10","left":"10","isLinked":true},"padding_horizontal_menu_item":{"unit":"px","size":15,"sizes":[]},"padding_horizontal_menu_item_tablet":{"unit":"px","size":"","sizes":[]},"padding_horizontal_menu_item_mobile":{"unit":"px","size":"","sizes":[]},"padding_vertical_menu_item":{"unit":"px","size":15,"sizes":[]},"padding_vertical_menu_item_tablet":{"unit":"px","size":"","sizes":[]},"padding_vertical_menu_item_mobile":{"unit":"px","size":"","sizes":[]},"menu_space_between_tablet":{"unit":"px","size":"","sizes":[]},"menu_space_between_mobile":{"unit":"px","size":"","sizes":[]},"menu_row_space":{"unit":"px","size":"","sizes":[]},"menu_row_space_tablet":{"unit":"px","size":"","sizes":[]},"menu_row_space_mobile":{"unit":"px","size":"","sizes":[]},"dropdown_border_radius_tablet":{"unit":"px","top":"","right":"","bottom":"","left":"","isLinked":true},"dropdown_border_radius_mobile":{"unit":"px","top":"","right":"","bottom":"","left":"","isLinked":true},"width_dropdown_item":{"unit":"px","size":"220","sizes":[]},"width_dropdown_item_tablet":{"unit":"px","size":"","sizes":[]},"width_dropdown_item_mobile":{"unit":"px","size":"","sizes":[]},"padding_horizontal_dropdown_item":{"unit":"px","size":"","sizes":[]},"padding_horizontal_dropdown_item_tablet":{"unit":"px","size":"","sizes":[]},"padding_horizontal_dropdown_item_mobile":{"unit":"px","size":"","sizes":[]},"padding_vertical_dropdown_item":{"unit":"px","size":15,"sizes":[]},"padding_vertical_dropdown_item_tablet":{"unit":"px","size":"","sizes":[]},"padding_vertical_dropdown_item_mobile":{"unit":"px","size":"","sizes":[]},"distance_from_menu":{"unit":"px","size":"","sizes":[]},"distance_from_menu_tablet":{"unit":"px","size":"","sizes":[]},"distance_from_menu_mobile":{"unit":"px","size":"","sizes":[]},"toggle_size":{"unit":"px","size":"","sizes":[]},"toggle_size_tablet":{"unit":"px","size":"","sizes":[]},"toggle_size_mobile":{"unit":"px","size":"","sizes":[]},"toggle_border_width":{"unit":"px","size":"","sizes":[]},"toggle_border_width_tablet":{"unit":"px","size":"","sizes":[]},"toggle_border_width_mobile":{"unit":"px","size":"","sizes":[]},"toggle_border_radius":{"unit":"px","size":"","sizes":[]},"toggle_border_radius_tablet":{"unit":"px","size":"","sizes":[]},"toggle_border_radius_mobile":{"unit":"px","size":"","sizes":[]}}'
                                                data-widget_type="navigation-menu.default"
                                            >
                                                <div className="elementor-widget-container">
                                                    <div
                                                        className="hfe-nav-menu hfe-layout-horizontal hfe-nav-menu-layout horizontal hfe-pointer__none"
                                                        data-layout="horizontal"
                                                    >
                                                        <div
                                                            role="button"
                                                            className="hfe-nav-menu__toggle elementor-clickable"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                            onClick={toggleClick}
                                                        >
                                                            <span className="screen-reader-text">Menu</span>

                                                            <div className="hfe-nav-menu-icon d-none" >
                                                                <i
                                                                    aria-hidden="true"
                                                                    className="fas fa-align-justify "

                                                                />
                                                                {" "}
                                                            </div>
                                                            <div className="bg-white">
                                                                {
                                                                    isOpen ? <CLOSE height='2rem' color='#012a4a' /> : <MENU height='2rem' color='#012a4a' />
                                                                }
                                                            </div>
                                                        </div>
                                                        <nav
                                                            className="hfe-nav-menu__layout-horizontal hfe-nav-menu__submenu-arrow"
                                                            data-toggle-icon='<i aria-hidden="true" tabindex="0" className="fas fa-align-justify"></i>'
                                                            data-close-icon='<i aria-hidden="true" tabindex="0" className="far fa-window-close"></i>'
                                                            data-full-width="yes"
                                                        >
                                                            <ul id="menu-1-5a43509" className="hfe-nav-menu prevent-select">
                                                                <li
                                                                    id="menu-item-398"
                                                                    className="menu-item menu-item-type-custom menu-item-object-custom parent hfe-creative-menu"
                                                                >

                                                                    <a href="/" className="hfe-menu-item"> Home </a>
                                                                </li>

                                                                <li
                                                                    id="menu-item-400"
                                                                    className="menu-item menu-item-type-custom menu-item-object-custom parent hfe-creative-menu"
                                                                >
                                                                    <a href="/services" className="hfe-menu-item">Services</a>
                                                                </li>
                                                                <li
                                                                    id="menu-item-400"
                                                                    className="menu-item menu-item-type-custom menu-item-object-custom parent hfe-creative-menu"
                                                                >
                                                                    <a href="/blogs" className="hfe-menu-item">Blogs</a>
                                                                </li>
                                                                <li
                                                                    id="menu-item-400"
                                                                    className="menu-item menu-item-type-custom menu-item-object-custom parent hfe-creative-menu"
                                                                >
                                                                    <a href="/about-us" className="hfe-menu-item" >About Us</a>
                                                                </li>
                                                                <li
                                                                    id="menu-item-402"
                                                                    className="menu-item menu-item-type-custom menu-item-object-custom parent hfe-creative-menu"
                                                                >
                                                                    <a href="/contact-us" className="hfe-menu-item" >  Contact Us</a>
                                                                </li>
                                                            </ul>
                                                        </nav>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </header>;
};

export default Header;

